import { render } from "./ArrowUp.vue?vue&type=template&id=35e276f8&scoped=true"
const script = {}

import "./ArrowUp.vue?vue&type=style&index=0&id=35e276f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.43_vue@3.5.43_typescript@7.0.2__webpack@5.111.0_postcss@8.5.28_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e276f8"]])

export default __exports__